/*
  Tohle je asi trochu prasárna, ale efektivně to řeší problém, kterej nemámě koncepčně
  podchycenej: jak po vybrání hodnoty zavolat callback s jistotou, že už ve stavu
  mám zavolat aktualizovanou hodnotu (tzn. onChange už proběhl)
 */

import { useEffect, useRef } from "react";

const useRunAfterOnchangeFinish = (
  callbackToRun: () => void,
  value: number | string | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  additionalDeps: any[]
) => {
  const shouldRun = useRef(false);
  const MUST_RUN_THIS_ON_CHANGE = () => {
    shouldRun.current = true;
  };

  useEffect(() => {
    if (shouldRun.current === true) {
      shouldRun.current = false;
      callbackToRun();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, ...additionalDeps]);

  return MUST_RUN_THIS_ON_CHANGE;
};

export default useRunAfterOnchangeFinish;
